import { useEffect, useState } from 'react';
import { useOperator } from '../../contexts/OperatorContext';
import {
  ApiSupportTicketCategory,
  ApiSupportTicketSubcategory,
  ApiSupportTicketSubcategoryChoice,
} from '../../types/apiTypes';
import {
  SupportTicketCategory,
  SupportTicketSubcategory,
  SupportTicketSubcategoryChoice,
} from '../../types/commonTypes';
import { useFetch } from '../useFetch';
import { useUser } from '../../contexts/UserContext';
import { BASE_URL_MAP } from '../../lib/environment';

export const useSupportTicketCategories = (getCategories?: boolean) => {
  const [categories, setCategories] = useState<SupportTicketCategory[]>([]);
  const { loading, makeRequest, response } = useFetch();
  const user = useUser();
  const operator = useOperator();

  useEffect(() => {
    if (
      getCategories &&
      ((operator.type === 'Hospitality' &&
        user.permissions.canHosSupportCreate) ||
        (operator.type === 'Residential' &&
          user.permissions.canResSupportCreate))
    ) {
      makeRequest(
        `${BASE_URL_MAP[operator.type]}/SupportTicket/Categories`,
        'get'
      );
    }
  }, [operator.type]);

  useEffect(() => {
    if (!loading && response) setCategories(mapCategories(response));
  }, [loading, response]);

  return categories;
};

const mapCategories = (
  response: ApiSupportTicketCategory[]
): SupportTicketCategory[] => {
  return response.map((category) => ({
    description: category.Description,
    id: category.ID,
    name: category.Name,
    subcategories: category.Subcategories.map((subcategory) =>
      mapSubcategory(subcategory)
    ),
  }));
};

const mapChoice = (
  choice: ApiSupportTicketSubcategoryChoice
): SupportTicketSubcategoryChoice => {
  return {
    id: choice.ID,
    subcategories: choice.Subcategories?.map((subcategory) =>
      mapSubcategory(subcategory)
    ),
    text: choice.Text,
  };
};

const mapSubcategory = (
  subcategory: ApiSupportTicketSubcategory
): SupportTicketSubcategory => {
  return {
    choices: subcategory.Choices?.map((choice) => mapChoice(choice)),
    id: subcategory.ID,
    name: subcategory.Name,
    required: subcategory.Required,
    type: subcategory.Type,
  };
};
